import './TagDescriptionSection.scss';

import { coreActions } from '@sonar-software/sonar-core';
import { Space } from 'antd';

import { COPY_SPECIFIC, PLACEHOLDERS_COPY, TAG_DESCRIPTION } from '@sonar-software/sonar-ts-constants';
import { PlaintextEditor, SonarText } from '@ui/text';
import React, { useCallback } from 'react';
import { useAction, useTagReference } from '@hooks';

export interface TagDescriptionSectionProps {
	tagId?: number;
}

export const TagDescriptionSection: React.FC<TagDescriptionSectionProps> = ({ tagId }) => {
	const tag = useTagReference(tagId);

	const requestPut = useAction(coreActions.requestPutCoreTagsById);

	const handleSave = useCallback((value: string) => {
		if (tagId && tag.description !== value) {
			requestPut({
				...tag,
				description: value
			});
		}
	}, [ requestPut, tag, tagId ]);

	return (
		<Space
			className='tag-description-section'
			direction='vertical'
			size={ 4 }>
			<SonarText
				size={ 16 }
				weight='semibold'>
				{ COPY_SPECIFIC.DESCRIPTION }
			</SonarText>
			<PlaintextEditor
				canBeEmpty
				isPeriscope
				isReadOnly={ tag.autoTagged }
				maxLength={ TAG_DESCRIPTION.MAX_LENGTH }
				maxRows={ 1 }
				onSave={ handleSave }
				placeholder={ PLACEHOLDERS_COPY.ADD_A_DESCRIPTION }
				saveOnEnter
				value={ tag.description } />
		</Space>
	);
};
